export const chatEvents = {
  OPEN_CHAT: "OPEN_CHAT",
  CLOSE_CHAT: "CLOSE_CHAT",
  CHAT_CLOSED: "CHAT_CLOSED",
  COMAGIC_ID: "COMAGIC_ID",
}

export const SERVER_URL = "https://proxy.chat.stage.agent.fsk-tech.ru"

const COMAGIC_IDS = {
  desktop: "77796",
  mobile: "78255",
}

export const MOBILE_REGEXP = /(android|iphone|ipod|ipad|blackberry|iemobile|kindle|silk|mobile|fennec|bb10|playbook|webos|opera mini)/i

export const getComagicId = () => {
  if (typeof navigator === "undefined") return COMAGIC_IDS.desktop
  return MOBILE_REGEXP.test(navigator.userAgent) ? COMAGIC_IDS.mobile : COMAGIC_IDS.desktop
}

export const MEETING_OK_RES =
  "Заполните форму для заказа обратного звонка. С вами свяжется менеджер и назначит удобную для вас дату встречи в офисе продаж"

export const CHAT_ROUTE = "sber-chat"

export const SESSION_ID_KEY = "chatBotSessionId"

export const COMAGIC_ID_KEY = "chatBotComagicId"

export const FIRST_MESSAGE =
  "Здравствуйте!<br><br>" +
  "Я — ваш персональный помощник по недвижимости от ФСК.<br><br>" +
  "Я здесь, чтобы сделать ваш путь к новой квартире максимально понятным, спокойным и комфортным.<br><br>" +
  "Подскажите, пожалуйста, что вам сейчас важно:<br>" +
  "1. Вопросы по уже приобретенной недвижимости<br>" +
  "2. Планирую покупку в ФСК/ДСК<br>" +
  "3. Запись на встречу<br>" +
  "4. Вопросы по сотрудничеству"

export const ERROR_MESSAGE = "Извините, произошла ошибка. Попробуйте позже."
